import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { IReportSearch } from '../interfaces/ireport-search';
import { ReportService } from '@core/services/report.service';
import { LanguageService } from '@core/services/language.service';
import { take } from 'rxjs';
import { IRequiredReportFields } from '../interfaces/irequired-report-fields';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '@core/enums/permissions';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-cohort-progress',
    templateUrl: './cohort-progress.component.html',
    styleUrls: ['./cohort-progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CohortProgressComponent implements OnInit {
  private reportService = inject(ReportService);
  private languageService = inject(LanguageService);
  private permissionService = inject(PermissionService);
  private route = inject(ActivatedRoute);
  private translocoService = inject(TranslocoService);
  is2025: boolean = false;
  title: string = '';
  hasAccessToAssignedChildren = this.permissionService.checkPermission(
    Permission.AccessToAssignedChildrenReporting
  );
  reportData:  string | undefined;
  loading: boolean = false;
  requiredFields: IRequiredReportFields = {
    state: true,
    agency: !this.hasAccessToAssignedChildren,
    globalRatingPeriod: true,
    site: false,
    classroom: false,
    ageGroup: true,
    requireMultipleRatingPeriods: true
  }
  constructor() { }

  ngOnInit(): void {
    this.is2025 = this.route.snapshot.data['is2025'] ?? false;
    this.title = this.translocoService.translate('reports.cohortProgress.title', { year: this.is2025 ? '2025' : '2015' });
    if (this.is2025) {
      this.requiredFields.ageGroup = false;
      this.requiredFields.requireRpInSameSchoolYear = false;
    }
  }
  showReport(searchValues: IReportSearch) {
    this.loading = true;
    if (!searchValues.locale) {
      searchValues.locale = this.languageService.activeId();
    }

    const service = (payload: IReportSearch) =>
      this.is2025
        ? this.reportService.generateCohortProgress2025Report(payload)
        : this.reportService.generateCohortProgressReport(payload);

    service(searchValues)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.reportData = res;
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  downloadReport(searchValues: IReportSearch) {
    this.loading = true;

    const service = (payload: IReportSearch) =>
      this.is2025
        ? this.reportService.generateCohortProgress2025ReportPdf(payload)
        : this.reportService.generateCohortProgressReportPdf(payload);

    service(searchValues)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          const file = new Blob([res], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = fileUrl;
          let fileName = `cohort_progress_report`;
          link.download = `${fileName.replace(/ /g, '_')}.pdf`;
          link.click();
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  handleClear(): void {
    this.reportData = undefined;
  }
}
